module.exports = __webpack_public_path__ + "static/media/street3.62b53d9f.png";